import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13d22ea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-list" }
const _hoisted_2 = { class: "tir-pm-list_wrapper" }

import { ref, provide, Ref, onMounted, computed, inject, ComputedRef, onBeforeUnmount } from 'vue';
import { TasksListWrapper, TaskGroup } from './components';
import { DragModel } from '../tir-pm-kanban';
import { ProjectQueueTaskListItem, TaskKanbanAdapterService } from '../tasks-kanban/adapter';
import { TasksKanbanFilter } from '../tasks-kanban/components';
import { TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from '../tasks-kanban/enums';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmScrollbar,
  TirToggle,
  TirPmPagination,
} from 'tir-components';
import {
  GetByParentTasksRequestModel,
  GroupedTaskItemModel,
  GroupedTaskRequestModel,
  TasksKanbanFilterModel,
  TaskModel,
  GetTaskListRequestSortModel,
} from '../tasks-kanban/models';
import { TaskModel as DrawerTaskModel } from '../task-forms/components/task-drawer/models';
import { useRouter } from 'vue-router';
import { TaskDrawer, TaskDrawerFormDataModel, TaskDrawerSettingsModel } from '../task-forms';
import { PlusIcon } from 'tir-style-system/icons/outline';
import { ListItemModel } from './models';
import TasksListWrapperSkeleton from './components/tasks-list-wrapper-skeleton.vue';
import { AttributesLocalStorageService } from '@/services';
import ListenTaskInfoAdapter from '../tasks-kanban/adapter/ListenTaskInfoAdapter';
import { OptionFilterEnum } from '../tasks-kanban/components/options-filter/enums';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';
import GetAccessCurrentUserInQueueTaskByIdRequestModel from './models/GetAccessCurrentUserInQueueTaskByIdRequestModel';
import { CriteriaSortingEnum } from './enums';

/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-list',
  setup(__props) {

const apiService = new TaskKanbanAdapterService();
/**Маршруты */
const router = useRouter();

const adapterListen = new ListenTaskInfoAdapter({
  CreateTasksEventFn: onCreateTask,
  RemoveTaskEventFn: getTasks,
});

/**Скрытые элементы */
const hiddenElements = [TaskViewElementEnum.Tags, TaskViewElementEnum.Queue];
/**Список группировок */
const groups = ref<GroupedTaskItemModel[]>([]);
/**Текущий перетаскиваемый компонент */
const currentDragging = ref<DragModel<TaskModel>>();
/**Доступы юзера к задаче */
const userAccess = ref<GetAccessCurrentUserInQueueTaskByIdResponseModel>();
/**Перетаскиваемый элемент */
provide<Ref<DragModel<TaskModel>>>('currentDragging', currentDragging);
/**Элемент над которым находится перетаскиваемый компонент */
const overDragging = ref<DragModel<TaskModel>>();
/**Элемент над которым находится перетаскиваемый объект */
provide<Ref<DragModel<TaskModel>>>('overDragging', overDragging);
/**Перетаскивается ли элемент */
const isDrag = ref<boolean>(false);
/**Фильтр */
const filter = ref(new TasksKanbanFilterModel({ ShowNestedTasks: true }));
/**Группировка */
const grouppingType = ref(TasksKanbanGrouppingTypeEnum.None);

/**Отображаемые элементы */
const viewElements = ref<TaskViewElementEnum[]>();

/**Ссылка на компонент шторки задачи */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
/**Ширина окна */
const windowWidth = ref(0);
/**Ширина сайдбара */
const sidebarWidth = ref(72);
/**Критерии сортировки */
const sortingСriteria = ref(new GetTaskListRequestSortModel());

/**Активен режим без группировки */
const isWithoutGroupping = computed(() => grouppingType.value == TasksKanbanGrouppingTypeEnum.None);

const checkGrouppingType = (type: TaskViewElementEnum) => {
  switch (type) {
    case TaskViewElementEnum.Status:
      return grouppingType.value != TasksKanbanGrouppingTypeEnum.Status;
    case TaskViewElementEnum.Performers:
      return grouppingType.value != TasksKanbanGrouppingTypeEnum.Performer;
    case TaskViewElementEnum.Priority:
      return grouppingType.value != TasksKanbanGrouppingTypeEnum.Priority;
    case TaskViewElementEnum.Type:
      return grouppingType.value != TasksKanbanGrouppingTypeEnum.Type;
    case TaskViewElementEnum.Tags:
      return grouppingType.value != TasksKanbanGrouppingTypeEnum.Tag;
    case TaskViewElementEnum.Author:
      return grouppingType.value != TasksKanbanGrouppingTypeEnum.Author;
    default:
      return true;
  }
};

/**Размеры колонок списка */
const listColumns = computed<ListItemModel[]>(() => {
  const list = [
    { Type: TaskViewElementEnum.Status, Name: 'Статус', Width: '12rem' },
    { Type: TaskViewElementEnum.Author, Name: 'Автор', Width: '4rem' },
    { Type: TaskViewElementEnum.Performers, Name: 'Исполнители', Width: '6rem' },
    { Type: TaskViewElementEnum.Observers, Name: 'Наблюдатели', Width: '8.125rem' },
    { Type: TaskViewElementEnum.Priority, Name: 'Приоритет', Width: '3rem' },
    { Type: TaskViewElementEnum.Difficulty, Name: 'Сложность', Width: '3rem' },
    { Type: TaskViewElementEnum.Type, Name: 'Тип задачи', Width: '6rem' },
    { Type: TaskViewElementEnum.Deadline, Name: 'Дедлайн', Width: '10rem' },
    { Type: TaskViewElementEnum.EstimateTime, Name: 't (оценка)', Width: '5rem' },
    { Type: TaskViewElementEnum.WorkTime, Name: 't (затрачено)', Width: '5rem' },
    { Type: TaskViewElementEnum.Tags, Name: 'Теги', Width: '12rem' },
    { Type: TaskViewElementEnum.DateCreate, Name: 'Дата создания', Width: '9rem' },
  ];

  return list.filter((x) => viewElements.value.includes(x.Type) && checkGrouppingType(x.Type));
});

/**Размер имени задачи */
const nameWidth = ref('30rem');
/**Активная сортировка */
const activeSortType = ref<TaskViewElementEnum | null>(null);

/**Id очереди */
const queueId = computed(() => {
  return router.currentRoute.value?.params?.queueId?.toString() || '';
});
provide('queueId', queueId);
/**Id проекта */
const projectId = computed(() => {
  return Number(router.currentRoute.value?.params?.projectId);
});
/**Id неймспейса */
const namespaceId = computed(() => {
  return router.currentRoute.value?.params?.namespaceId?.toString() || '';
});
/**Стили скролла */
const scrollStyle = computed(() => {
  let h = `calc(100vh - 19rem})`;
  if (filterEl?.value?.clientHeight) {
    const rect = filterEl?.value.getBoundingClientRect();
    h = `calc(100vh - ${getRem(rect.height) + 16 + 'rem'})`;
  }
  return {
    maxWidth: `calc(${getRem(windowWidth.value)}rem - ${getRem(sidebarWidth.value)}rem - 7.5rem)`,
    maxHeight: h,
    height: h,
  };
});
/**rem единица */
const rem = computed(() => parseFloat(getComputedStyle(document.documentElement).fontSize));

const acceptViewElements = [
  TaskViewElementEnum.Author,
  TaskViewElementEnum.Performers,
  TaskViewElementEnum.Observers,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.Type,
  TaskViewElementEnum.DateCreate,
  TaskViewElementEnum.Difficulty,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
  TaskViewElementEnum.Deadline,
];

const defaultAcceptViewElements = [
  TaskViewElementEnum.Status,
  TaskViewElementEnum.Performers,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.Type,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
];

/**После рендера */
onMounted(async () => {
  grouppingType.value =
    AttributesLocalStorageService.getGrouppingType(queueId.value, 'task-list') ??
    TasksKanbanGrouppingTypeEnum.None;

  viewElements.value = AttributesLocalStorageService.getViewElements(queueId.value);
  if (!viewElements.value) viewElements.value = defaultAcceptViewElements;

  viewElements.value = viewElements.value.filter((e) => acceptViewElements.includes(e));

  viewElements.value = viewElements.value;

  await getAccessCurrentUserInQueueTask();
  onWindowResize();
  window.addEventListener('resize', onWindowResize);
  document.addEventListener('sidebar-resize', onSidebarResize);
  await getTasks();
});
/**Перед удалением компонента */
onBeforeUnmount(() => {
  window.removeEventListener('resize', onWindowResize);
  document.removeEventListener('sidebar-resize', onSidebarResize);
});

/**Получить rem значение */
const getRem = (px: number) => {
  if (!px) return 0;
  return px / rem.value;
};
/**Получение доступов по текущему пользователю в очереди задач по идентификатору */
const getAccessCurrentUserInQueueTask = async () => {
  const response = await apiService.getAccessCurrentUserInQueueTaskById(
    new GetAccessCurrentUserInQueueTaskByIdRequestModel({
      QueueTaskId: queueId.value,
    }),
  );
  if (response.IsSuccess) {
    userAccess.value = response.Value;
  }
};
/**При изменении размеров окна */
function onWindowResize() {
  windowWidth.value = document.body.clientWidth;
}
/**При изменении размеров сайдбара */
function onSidebarResize(e: CustomEventInit) {
  sidebarWidth.value = Number(e.detail);
}
/**Получение списка задач */
async function getTasks() {
  if (!queueId.value) return;

  const response = await apiService.getGroupedTaskList(
    new GroupedTaskRequestModel({
      GrouppedBy: grouppingType.value,
      QueueTaskId: queueId.value,
      ViewSettings: {
        showNestedTasks:
          filter.value.ShowNestedTasks && grouppingType.value === TasksKanbanGrouppingTypeEnum.None,
        viewElements: viewElements.value,
      },
      Sort: new GetTaskListRequestSortModel(sortingСriteria.value),
      Search: filter.value.Search,
    }),
  );
  if (response.IsSuccess) {
    groups.value = response.Value;
  }
}
/**Сортировка списка */
const sortingList = async (type: TaskViewElementEnum) => {
  activeSortType.value = activeSortType.value === type ? null : type;
  const keyMap = {
    [TaskViewElementEnum.Priority]: CriteriaSortingEnum.SortByPriority,
    [TaskViewElementEnum.Difficulty]: CriteriaSortingEnum.SortByDifficulty,
    [TaskViewElementEnum.Deadline]: CriteriaSortingEnum.SortByDeadline,
    [TaskViewElementEnum.EstimateTime]: CriteriaSortingEnum.SortByEstimatedTime,
    [TaskViewElementEnum.WorkTime]: CriteriaSortingEnum.SortBySpentTime,
  };
  const sortingElement = keyMap[type];

  const newSorting = {};

  // Сбрасываем все в false, кроме выбранного ключа, который инвертируем
  for (const key in keyMap) {
    const sortKey = keyMap[key];
    newSorting[sortKey] = sortKey === sortingElement ? !sortingСriteria.value[sortKey] : null;
  }

  sortingСriteria.value = newSorting;
  await getTasks();
};

/** очистка данных о перетаскиваемом элементе */
function onUpdateCleanFlag() {
  currentDragging.value = undefined;
  overDragging.value = undefined;
  isDrag.value = false;
}

/** перетаскивание элемента */
const dragComponentOnDrag = (isDragging: boolean, model: DragModel<TaskModel>) => {
  isDrag.value = isDragging;
  if (!isDrag.value) {
    onUpdateCleanFlag();
  } else {
    currentDragging.value = model;
  }
};

/** поиск элемента над которым перетаскивается элемент */
const dragComponentOnOver = (isOver: boolean, model: DragModel<TaskModel>) => {
  overDragging.value = model;
};

/**Перемещение узла с тасками */
const moveTask = async (parent: DragModel<TaskModel | GroupedTaskItemModel>, task?: TaskModel) => {
  const dragging = task || currentDragging.value?.Data;
  const parentItem = (parent?.Data ? parent.Data : parent) as TaskModel | GroupedTaskItemModel;
  if (!parentItem || !dragging || dragging.Id == parent?.Data.Id) return;

  if (
    ((parentItem as GroupedTaskItemModel).Items || (parentItem as TaskModel).Subtasks).some(
      (task) => task.Id == dragging.Id,
    )
  ) {
    return;
  }

  if (typeof parentItem.Id == 'string') {
    const target = parentItem as GroupedTaskItemModel;

    const isSubtask = groups.value.every((g) => !g.Items.some((x) => x.Id == dragging.Id));
    if (isSubtask) {
      const response = await apiService.removeSubtask(dragging.Id);
      if (!response.IsSuccess) return;
    }

    removeTaskFromTree(dragging.Id);

    target.Items.push(dragging);
    console.log(task);
    updateTaskByGroupping(dragging, target);
  } else {
    const target = parentItem as TaskModel;
    const response = await apiService.attachSubtask(dragging.Id, target.Id);
    if (!response.IsSuccess) return;

    removeTaskFromTree(dragging.Id);
    addSubtask(target, dragging);
  }
};
/**Добавление подзадачи */
const addSubtask = (parent: TaskModel, task: TaskModel) => {
  task.ParentTaskId = parent.Id;
  changeSubtasksCount(parent, task, 1);
  if (parent.Subtasks?.length) {
    parent.Subtasks.push(task);
  } else {
    parent.Subtasks = [task];
  }
};
/**Смена количества подзадач */
const changeSubtasksCount = (parent: TaskModel, task: TaskModel, value: number) => {
  const isCurrentQueue = task.Queues.some((q) => q.Id == queueId.value);
  if (isCurrentQueue) {
    parent.CurrentQueueSubtaskCount += value;
  } else {
    parent.OtherQueueSubtaskCount += value;
  }
};
/**Обновление задачи по группировке */
const updateTaskByGroupping = (task: TaskModel, group: GroupedTaskItemModel) => {
  switch (grouppingType.value) {
    case TasksKanbanGrouppingTypeEnum.Status:
      apiService.updateStatus({ TaskId: task.Id, StatusId: group?.Status?.Id });
      break;
    case TasksKanbanGrouppingTypeEnum.Priority:
      apiService.updatePriority({ TaskId: task.Id, PriorityId: group?.Priority?.Id });
      break;
    case TasksKanbanGrouppingTypeEnum.Type:
      apiService.updateTaskType({ TaskId: task.Id, TaskTypeId: group?.Type?.Id });
      break;
  }
};
/**Удаление задачи из дерева */
const removeTaskFromTree = (taskId: number) => {
  const fromGroup = groups.value.find((group) => group.Items.some((task) => task.Id == taskId));
  if (fromGroup) {
    setTimeout(() => (fromGroup.Items = fromGroup.Items.filter((t) => t.Id != taskId)));
  } else {
    let parent: TaskModel;
    groups.value.forEach((group) => {
      if (!parent) {
        parent = findParentBySubtaskId(group.Items, taskId);
        return;
      }
    });
    const task = parent?.Subtasks.find((t) => t.Id == taskId);
    if (parent && task) removeSubtask(parent, task);
  }
};
/**Удаление подзадачи */
const removeSubtask = (parent: TaskModel, task: TaskModel) => {
  task.ParentTaskId = undefined;
  changeSubtasksCount(parent, task, -1);
  parent.Subtasks = parent.Subtasks.filter((t) => t.Id != task.Id);
};
/**Поиск родителя по id подзадачи */
function findParentBySubtaskId(tasks: TaskModel[], subtaskId: number) {
  for (const task of tasks) {
    // Проверяем сабтаски текущего объекта
    if (task.Subtasks.some((subtask) => subtask.Id === subtaskId)) {
      return task;
    }
    // Рекурсивный вызов для сабтасков текущего объекта
    for (const subtask of task.Subtasks) {
      const result = findParentBySubtaskId([subtask], subtaskId);
      if (result) {
        return result;
      }
    }
  }
}
/**Поиск задачи по Id */
function findTaskById(taskId: number, tasksList?: TaskModel[]) {
  const tasks = tasksList || groups.value.map((g) => g.Items).flat();
  for (const task of tasks) {
    // Проверяем сабтаски текущего объекта
    if (task.Id === taskId) return task;
    // Рекурсивный вызов для сабтасков текущего объекта
    const result = findTaskById(taskId, task.Subtasks);
    if (result) return result;
  }
}
/** находим и возвращаем узел дерева */
const findAndRemoveNode = (tasks: TaskModel[], id: number) => {
  for (let i = 0; i < tasks.length; i++) {
    if (tasks[i].Id === id) {
      return tasks.splice(i, 1)[0];
    }
    if (tasks[i].Subtasks && tasks[i].Subtasks.length > 0) {
      const result = findAndRemoveNode(tasks[i].Subtasks, id);
      if (result) return result;
    }
  }
  return null;
};
/**Смена группировки */
const selectGrouppingType = async (_grouppingType: TasksKanbanGrouppingTypeEnum) => {
  grouppingType.value = _grouppingType;
  AttributesLocalStorageService.saveGrouppingType(queueId.value, _grouppingType, 'task-list');
  getTasks();
};
/**Смена настроек карточек */
const updateViewElements = async (_viewElements: Array<TaskViewElementEnum>) => {
  viewElements.value = _viewElements;
  AttributesLocalStorageService.saveViewElements(queueId.value, _viewElements);

  getTasks();
};
/**Событие для открытия окна создания задачи */
const createTask = (form: TaskDrawerFormDataModel) => {
  if (!projectId.value || !queueId.value) return;
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'create',
      ProjectId: projectId.value,
      QueueId: queueId.value,
      NamespaceId: namespaceId.value,
      FormData: form,
    }),
  );
};
/**Загрузить подзадачи */
const loadSubtasks = async (task: TaskModel) => {
  const response = await apiService.getByParentTaskList(
    new GetByParentTasksRequestModel({
      ParentId: task.Id,
      QueueTaskId: queueId.value,
      ViewSettings: {
        showNestedTasks: filter.value.ShowNestedTasks,
        viewElements: viewElements.value,
      },
    }),
  );

  if (response.IsSuccess) {
    task.Subtasks = response.Value;
  }
};
/**При создании задачи */
function onCreateTask() {
  $taskDrawer.value?.close();
  getTasks();
}
/**Группа редактируемой задачи */
const editTaskGroup = ref<GroupedTaskItemModel>();
/**Открыть шторку с детальной задачи  */
const openTask = (taskId: number, group: GroupedTaskItemModel) => {
  editTaskGroup.value = group;
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: taskId,
    }),
  );
};

/**При редактировании задачи */
const onUpdateTask = (task: DrawerTaskModel) => {
  if (!editTaskGroup.value) return;
  const taskParent = findParentBySubtaskId(editTaskGroup.value.Items, task.Id);

  const subtasks = taskParent ? (taskParent as TaskModel).Subtasks : editTaskGroup.value.Items;
  const editTask = subtasks.find((t) => t.Id == task.Id);

  Object.assign(editTask, task);

  if (taskParent && !task.Parent) {
    const removingTask = taskParent?.Subtasks.find((t) => t.Id == task.Id);
    if (removingTask) removeSubtask(taskParent, removingTask);

    const targetGroup = getGroupForTask(task);
    if (targetGroup) {
      editTask.ParentTaskId = undefined;
      targetGroup.Items.push(editTask);
    }
  }
};
/**Получение группы для задачи */
const getGroupForTask = (task: TaskModel | DrawerTaskModel) => {
  let targetGroup: GroupedTaskItemModel;
  switch (grouppingType.value) {
    case TasksKanbanGrouppingTypeEnum.Status:
      targetGroup = groups.value.find((g) => g.Status.Id == task.Status.Id);
      break;
    case TasksKanbanGrouppingTypeEnum.Priority:
      targetGroup = groups.value.find((g) => g.Priority.Id == task.Priority.Id);
      break;
    case TasksKanbanGrouppingTypeEnum.Type:
      targetGroup = groups.value.find(
        (g) => g.Type.Id == (task as DrawerTaskModel).TypeId || (task as TaskModel)?.Type?.Id,
      );
      break;
  }
  return targetGroup;
};
/**Установка подзадачи */
const setSubtask = (parentTaskId: number, taskId: number) => {
  const taskParent = findTaskById(parentTaskId);
  const task = findTaskById(taskId);
  if (taskParent && task) {
    removeTaskFromTree(task.Id);
    addSubtask(taskParent, task);
  }
};
/**Открепление подзадачи */
const unattachSubtask = (subtaskId: number) => {
  const task = findTaskById(subtaskId);
  const parent = findParentBySubtaskId(editTaskGroup.value.Items, subtaskId);
  if (!task || !parent) return;
  removeSubtask(parent, task);

  const taskGroup = getGroupForTask(task);
  if (taskGroup) taskGroup.Items.push(task);
};
const currentQueue = inject('currentQueue') as ComputedRef<ProjectQueueTaskListItem>;
const isCanAddTask = inject('isCanAddTask') as ComputedRef<Boolean>;
const filterEl = ref();
const hidedOptionsFilter = ref([OptionFilterEnum.Projects]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "tir-pm-list_filter",
        ref_key: "filterEl",
        ref: filterEl
      }, [
        _createVNode(_unref(TasksKanbanFilter), {
          isHideSorting: "",
          allowNoneGroupping: "",
          "groupping-type": grouppingType.value,
          "view-elements": viewElements.value,
          "hidden-view-elements": hiddenElements,
          filter: filter.value,
          "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
          "is-disabled-filter": 
          grouppingType.value !== _unref(TasksKanbanGrouppingTypeEnum).None || filter.value.ShowNestedTasks
        ,
          "is-disabled-search": filter.value.ShowNestedTasks,
          noAccessTooltip: filter.value.ShowNestedTasks ? 'Доступно, если отключить вложенность' : '',
          "onUpdate:grouppingType": selectGrouppingType,
          "onUpdate:viewElements": updateViewElements,
          onOnSearch: getTasks,
          hidedOptionsFilter: hidedOptionsFilter.value,
          projectId: projectId.value,
          namespaceId: namespaceId.value,
          queueId: queueId.value
        }, null, 8, ["groupping-type", "view-elements", "filter", "is-disabled-filter", "is-disabled-search", "noAccessTooltip", "hidedOptionsFilter", "projectId", "namespaceId", "queueId"]),
        (isWithoutGroupping.value)
          ? (_openBlock(), _createBlock(_unref(TirToggle), {
              key: 0,
              modelValue: filter.value.ShowNestedTasks,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((filter.value.ShowNestedTasks) = $event)),
                getTasks
              ]
            }, {
              mainSign: _withCtx(() => [
                _createTextVNode(" Показать вложенность ")
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(TirPmButton), {
          "is-disabled": !_unref(currentQueue).IsConfigured || !_unref(isCanAddTask),
          class: "tir-pm-list_button",
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          size: _unref(TirPmButtonSizeEnum).Small,
          onClick: createTask,
          style: {"min-width":"2rem"}
        }, {
          leftSlot: _withCtx(() => [
            _createVNode(_unref(PlusIcon))
          ]),
          _: 1
        }, 8, ["is-disabled", "variant", "size"])
      ], 512),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(TirPmScrollbar), {
          style: _normalizeStyle(scrollStyle.value),
          "show-on-hover": true,
          enableVerticalAutoscroll: !!currentDragging.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
              return (_openBlock(), _createBlock(_unref(TaskGroup), {
                key: group.Id,
                group: group,
                grouppingType: grouppingType.value,
                nameWidth: nameWidth.value,
                listColumns: listColumns.value,
                activeSortType: activeSortType.value,
                onDragComponentOnDrop: moveTask,
                onCreate: createTask,
                onSortingList: sortingList
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TasksListWrapper), {
                    tasks: group.Items,
                    "sortingСriteria": sortingСriteria.value,
                    userAccess: userAccess.value,
                    group: group,
                    "groupping-type": grouppingType.value,
                    nameWidth: nameWidth.value,
                    listColumns: listColumns.value,
                    "visible-task-group-data": true,
                    "visible-task-group-data-start-level": 1,
                    onOpen: ($event: any) => (openTask($event, group)),
                    onRemoveTask: removeTaskFromTree,
                    onDragComponentOnDrag: dragComponentOnDrag,
                    onDragComponentOnOver: dragComponentOnOver,
                    onDragComponentOnDrop: moveTask,
                    onLoadSubtasks: loadSubtasks
                  }, null, 8, ["tasks", "sortingСriteria", "userAccess", "group", "groupping-type", "nameWidth", "listColumns", "onOpen"])
                ]),
                _: 2
              }, 1032, ["group", "grouppingType", "nameWidth", "listColumns", "activeSortType"]))
            }), 128)),
            (!groups.value.length)
              ? (_openBlock(), _createBlock(TasksListWrapperSkeleton, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style", "enableVerticalAutoscroll"])
      ])
    ]),
    _createVNode(_unref(TaskDrawer), {
      ref_key: "$taskDrawer",
      ref: $taskDrawer,
      onOnCreateTask: onCreateTask,
      onOnUpdateTask: onUpdateTask,
      onSubtaskItem: setSubtask,
      onRemoveSubtaskItem: unattachSubtask
    }, null, 512)
  ], 64))
}
}

})